<template>
    <base-dblclick-input
      class="inline"
      model-type="contactClientRelationship"
      :model-id="clientContact.id"
      field-name="phone_number"
      :field-value="clientContact.phone_number"
      input-type="text"
      @refetch="fetchNewClients"
    >
      <slot name="icon"></slot>
    </base-dblclick-input>
  </template>
  
  <script setup>
  import { defineProps, defineEmits } from "vue";
  
    const props = defineProps(['clientContact'])
  
    const emit = defineEmits(['refetch-clients'])
  
    function fetchNewClients () {
        emit('refetch-clients')
    }
  
  </script>